import {
  House,
  HandWaving,
  Fire,
  BookOpen,
  Lightning,
  NotePencil,
  Trophy,
  ClockCounterClockwise,
} from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../../library/LibraryPrimitives";
import { AreaNode, Matrix } from "../diagrams";

const SECTIONS = [
  { icon: HandWaving, label: "Greeting", purpose: "A warm, personal hello", tone: "orange" },
  { icon: Fire, label: "Streak card", purpose: "Gentle daily habit", tone: "orange" },
  { icon: BookOpen, label: "Continue learning", purpose: "One clear next step", tone: "blue" },
  { icon: Lightning, label: "Daily challenge", purpose: "A fun, optional spark", tone: "yellow" },
  { icon: NotePencil, label: "Homework due", purpose: "Friendly reminders", tone: "teal" },
  { icon: Trophy, label: "Recent achievements", purpose: "Celebrate the wins", tone: "yellow" },
  { icon: ClockCounterClockwise, label: "Activity timeline", purpose: "What happened lately", tone: "neutral" },
];

export function HomeSection() {
  return (
    <SectionShell
      id="home"
      eyebrow="Home"
      eyebrowIcon={House}
      title="A calm place to continue & belong"
      description="Home exists to help children pick up where they left off and build a gentle daily habit — never a wall of options. It opens with one obvious, friendly thing to do."
    >
      <div className="space-y-8">
        <Showcase title="Possible sections" description="Composed from the component library — ordered by what matters today" tone="muted">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {SECTIONS.map((s) => (
              <AreaNode key={s.label} icon={s.icon} label={s.label} purpose={s.purpose} tone={s.tone} />
            ))}
          </div>
        </Showcase>

        <Showcase title="How Home evolves by age">
          <Matrix
            firstColLabel="Element"
            columns={["Years 1–2", "Years 3–4", "Years 5–6"]}
            rows={[
              { label: "Greeting", values: ["Big mascot + spoken “Hi!”", "Friendly hello + streak", "Compact, calm greeting"] },
              { label: "Hero focus", values: ["A story or quick play", "Continue + daily challenge", "Continue + weekly goal"] },
              { label: "Homework", values: ["Soft, optional nudge", "Clear due-today list", "Self-managed overview"] },
              { label: "Density", values: ["1–2 large cards", "3–4 cards", "Denser, scannable"] },
              { label: "Motion", values: ["Playful & expressive", "Standard & delightful", "Subtle & quiet"] },
            ]}
          />
        </Showcase>
      </div>
    </SectionShell>
  );
}

export default HomeSection;
